import React from 'react';
import { useCondition } from '../../../../ConditionSelector/useCondition';
import { ClinicFormProps, ClinicIdProps } from '../../../CreateClinic/types';
import ConditionEditor from '.';
import OutlinedContainer from '../ClinicConditionList/OutlinedContainer.styled';
import { useSelector } from 'react-redux';
import { selectEditedConditionId } from '../../../../../redux/clinics/selectors';

type ClinicConditionEditorContainerProps = ClinicFormProps & ClinicIdProps;

const ClinicConditionEditorContainer = ({ form, clinicId }: ClinicConditionEditorContainerProps) => {
  const { editedCondition, editedConditionIndex } = useEditedClinicCondition({ form });

  const { condition } = useCondition(editedCondition?.condition_id);

  if (!editedCondition) {
    return null;
  }

  return (
    <OutlinedContainer key={editedCondition._id}>
      <ConditionEditor
        clinicId={clinicId}
        index={editedConditionIndex}
        condition={condition}
        form={form}
      />
    </OutlinedContainer>
  );
};

const useEditedClinicCondition = ({ form }: ClinicFormProps) => {
  const conditions = form.watch('clinic_conditions');
  const editedConditionId = useEditedConditionId();
  const editedConditionIndex = conditions.findIndex(condition => condition._id === editedConditionId);
  const editedCondition = conditions[editedConditionIndex];

  return { editedCondition, editedConditionIndex };
};

const useEditedConditionId = () => {
  return useSelector(selectEditedConditionId);
};

export default ClinicConditionEditorContainer;
